import { render } from "./burger.vue?vue&type=template&id=a7d0b622&scoped=true"
import script from "./burger.vue?vue&type=script&lang=js"
export * from "./burger.vue?vue&type=script&lang=js"

import "./burger.vue?vue&type=style&index=0&id=a7d0b622&scoped=true&lang=css"

import exportComponent from "C:\\Users\\krist\\Documents\\pbetoon\\pBetoon-main\\ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7d0b622"]])

export default __exports__